import React, { FC } from 'react'
import { IApplication } from 'core/interfaces/Application'
import { ApplicationCardMobile } from 'lauria/components/dashboard/ApplicationCardMobile'
import { generatePath, useNavigate } from 'react-router'
import { ROUTE_PATHS } from 'core/constants/routePath'
import { groupByService } from 'core/utils/service'
import { IconComponent } from 'core/components/common/IconComponent'

export const ApplicationCardListMobile: FC<{
  applications: IApplication[]
}> = ({ applications }) => {
  const navigate = useNavigate()
  const appsByService = groupByService(applications)
  const redirectApp = (appId: number) => {
    navigate(generatePath(ROUTE_PATHS.PROMPTS, { idApplication: appId }))
  }
  return (
    <div className="w-full">
      {Object.entries(appsByService).map(
        ([serviceName, { serviceIcon, service, apps }]) => (
          <div key={serviceName} className="mb-[30px]">
            <div className="font-semibold text-base mb-[15px] flex flex-row items-center">
              <IconComponent
                iconInfo={serviceIcon}
                className="h-[40px] w-[40px] mr-[10px]"
              />
              <span style={{ color: service.colorBackground }}>
                {serviceName}
              </span>
            </div>
            <div className="flex flex-row w-full overflow-x-scroll">
              {apps.map((app) => {
                return (
                  <ApplicationCardMobile
                    key={app.id}
                    application={app}
                    handleClick={() => redirectApp(app.id)}
                  />
                )
              })}
            </div>
          </div>
        )
      )}
    </div>
  )
}
